import {
  BooleanInput,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
} from "react-admin";

export const DoctorEdit = (props) => {
  return (
    <Edit>
      <SimpleForm>
        <TextInput source="name" />
        <TextInput source="vicinity" />
        <NumberInput source="rating" />
        <NumberInput source="website" />
        <TextInput source="formattedPhoneNumber" />
        <BooleanInput source="recommended" />
      </SimpleForm>
    </Edit>
  );
};
